<div class="benefits website-container">
    <ng-template #saveTimeCard>
      <app-card class="benefit-card benefit-save-time-card" [config]="{
        background: 'accented-1',
      }">
        <div class="bst-one">
          <div class="card-title">{{ 'WEBSITE.BENEFITS.SAVE_TIME.TITLE' | translate }}</div>
          <div class="card-description">{{ 'WEBSITE.BENEFITS.SAVE_TIME.DESCRIPTION' | translate }}</div>
        </div>

        <div class="bst-two">
          <figure class="save-time-img-wrapper">
            <img class="save-time-img" src="/assets/img/website/b_save_time.png" alt="Save time img">
          </figure>
        </div>
      </app-card>
  </ng-template>

    <ng-template #statisticsCard>
      <app-card class="benefit-card benefit-statistics-card">
        <div class="card-title">{{ 'WEBSITE.BENEFITS.STATISTICS.TITLE' | translate }}</div>
        <div class="card-description">{{ 'WEBSITE.BENEFITS.STATISTICS.DESCRIPTION' | translate }}</div>
        <figure class="statistics-img-wrapper">
          <img class="statistics-img" src="/assets/img/website/b_statistics.svg" alt="Statistics graph img">
        </figure>
      </app-card>
    </ng-template>

    <ng-template #useEverywhereCard>
      <app-card class="benefit-card benefit-use-everywhere-card">
        <div class="card-title">{{ 'WEBSITE.BENEFITS.USE_EVERYWHERE.TITLE' | translate }}</div>
        <div class="card-description">{{ 'WEBSITE.BENEFITS.USE_EVERYWHERE.DESCRIPTION' | translate }}</div>
        <figure class="use-everywhere-img-wrapper">
          <img class="use-everywhere-img" src="/assets/img/website/b_use_everywhere.svg" alt="Use everywhere img">
        </figure>
      </app-card>
    </ng-template>

    <ng-template #keepSimpleCard>
      <app-card class="benefit-card benefit-keep-simple-card">
        <div class="card-title">{{ 'WEBSITE.BENEFITS.KEEP_SIMPLE.TITLE' | translate }}</div>
        <div class="card-description card-description-bg">{{ 'WEBSITE.BENEFITS.KEEP_SIMPLE.DESCRIPTION' | translate }}</div>
      </app-card>
    </ng-template>

    <ng-template #unlockFeaturesCard>
      <app-card class="benefit-card benefit-unlock-features-card">
        <div class="unlock-f-intro">
          <div class="card-title">{{ 'WEBSITE.BENEFITS.UNLOCK_FEATURES.TITLE' | translate }}</div>
          <div class="card-description">{{ 'WEBSITE.BENEFITS.UNLOCK_FEATURES.DESCRIPTION' | translate }}</div>
        </div>

        <div class="unlock-f-images-wrapper">
          <figure class="unlock-f-image-wrapper"><img src="/assets/img/website/logos_colored/google_calendar.svg" alt="Google Calendar logo" class="l-google-c"></figure>
          <figure class="unlock-f-image-wrapper"><img src="/assets/img/website/logos_colored/finn.svg" alt="Finn logo"></figure>
          <figure class="unlock-f-image-wrapper"><img src="/assets/img/website/logos_colored/jobtip.svg" alt="Jobtip logo"></figure>
          <figure class="unlock-f-image-wrapper"><img src="/assets/img/website/logos_colored/gobi.svg" alt="Gobi logo"></figure>
          <figure class="unlock-f-image-wrapper"><img src="/assets/img/website/logos_colored/simployer.svg" alt="Simployer logo" class="l-simployer"></figure>
          <figure class="unlock-f-image-wrapper"><img src="/assets/img/website/logos_colored/huma.svg" alt="Huma logo" class="l-huma"></figure>
          <figure class="unlock-f-image-wrapper"><img src="/assets/img/website/logos_colored/aider.svg" alt="Aider logo"></figure>
          <figure class="unlock-f-image-wrapper unlock-f-image-wrapper-smn">
            <img src="/assets/img/website/logos_colored/SMN.svg" alt="Spare bank SMN logo" class="l-smn"/>
          </figure>
        </div>
      </app-card>
    </ng-template>

    <ng-template #secureCard>
      <app-card
        class="benefit-card benefit-secure-card"
        [config]="{
          background: 'accented-1'
        }">
        <div class="card-title">{{ 'WEBSITE.BENEFITS.SECURE.TITLE' | translate }}</div>

        <div class="card-description">{{ 'WEBSITE.BENEFITS.SECURE.DESCRIPTION' | translate }}</div>

        <figure class="secure-img-wrapper">
          <img class="secure-img" src="/assets/img/website/lock.svg" alt="Secure img">
        </figure>
      </app-card>
    </ng-template>

    <ng-template #donationsCard>
      <app-card class="benefit-card benefit-donations-card">
        <div class="intro mb-58">
          <div class="card-title">{{ 'WEBSITE.BENEFITS.DONATIONS.TITLE' | translate }}</div>
          <div class="card-description">{{ 'WEBSITE.BENEFITS.DONATIONS.DESCRIPTION' | translate }}</div>
        </div>

        <div class="donations">
          @if (donationAmounts) {
            <div class="card-title">{{donationAmounts}} {{ 'WEBSITE.BENEFITS.DONATIONS.AMOUNT' | translate }}</div>
          }

          <div class="card-description">{{ 'WEBSITE.BENEFITS.DONATIONS.START' | translate }}</div>
        </div>

        <div class="outro">
          <img class="rb-logo" src="/assets/img/website/redd_barna_logo.svg" alt="Redd Barna logo">
        </div>
      </app-card>
    </ng-template>

  <!-- Use templates in ng-containers -->
  @if (isMobile) {
    <ng-container *ngTemplateOutlet="saveTimeCard"></ng-container>
    <ng-container *ngTemplateOutlet="statisticsCard"></ng-container>
    <ng-container *ngTemplateOutlet="useEverywhereCard"></ng-container>
    <ng-container *ngTemplateOutlet="keepSimpleCard"></ng-container>
    <ng-container *ngTemplateOutlet="unlockFeaturesCard"></ng-container>
    <ng-container *ngTemplateOutlet="secureCard"></ng-container>
    <ng-container *ngTemplateOutlet="donationsCard"></ng-container>
  }

  @if (isTablet) {
    <ng-container *ngTemplateOutlet="saveTimeCard"></ng-container>
    <ng-container *ngTemplateOutlet="statisticsCard"></ng-container>
    <ng-container *ngTemplateOutlet="useEverywhereCard"></ng-container>
    <ng-container *ngTemplateOutlet="unlockFeaturesCard"></ng-container>
    <ng-container *ngTemplateOutlet="keepSimpleCard"></ng-container>
    <ng-container *ngTemplateOutlet="secureCard"></ng-container>
    <ng-container *ngTemplateOutlet="donationsCard"></ng-container>
  }

  @if (isDesktop) {
    <ng-container *ngTemplateOutlet="saveTimeCard"></ng-container>
    <ng-container *ngTemplateOutlet="statisticsCard"></ng-container>
    <ng-container *ngTemplateOutlet="useEverywhereCard"></ng-container>
    <ng-container *ngTemplateOutlet="keepSimpleCard"></ng-container>
    <ng-container *ngTemplateOutlet="unlockFeaturesCard"></ng-container>
    <ng-container *ngTemplateOutlet="secureCard"></ng-container>
    <ng-container *ngTemplateOutlet="donationsCard"></ng-container>
  }

</div>
